import { SocialPublishAtField } from '@app/modules/social-export/components/inputs/SocialPublishAtField';
import { TextFieldElementWithEmoji } from '@app/modules/social-export/components/inputs/TextFieldElementWithEmoji';
import { PublishFormUnsavedChangesWarning } from '@app/modules/social-export/components/PublishFormUnsavedChangesWarning';
import { BaseExportFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { FormSectionV2 } from '@app/core/components/FormSectionV2';
import { zodResolver } from '@hookform/resolvers/zod';
import { Grid, Stack } from '@mui/material';
import { FormContainer } from 'react-hook-form-mui';
import { useIntl } from 'react-intl';
import { DemoSettingsDto } from '../../social-export.types';
import { DemoPublishValues, useDemoPublishSchema } from './useDemoPublishSchema';

type DemoPublishFormProps = BaseExportFormProps<DemoPublishValues, DemoSettingsDto>;

export function DemoPublishForm({ source, onUpload, actions }: DemoPublishFormProps) {
  const { $t } = useIntl();
  const schema = useDemoPublishSchema();
  const initialValues: DemoPublishValues = {
    title: source.title ?? '',
    description: source.description ?? '',
    publishAt: null,
  };

  return (
    <FormContainer
      values={initialValues}
      mode="onBlur"
      resolver={zodResolver(schema)}
      onSuccess={async (formData) => {
        await onUpload(formData);
      }}
    >
      <PublishFormUnsavedChangesWarning />
      <FormSectionV2
        title={$t({
          id: 'socialExport.form.demoData',
          defaultMessage: 'Datos de demo',
        })}
      >
        <Stack spacing={3}>
          <TextFieldElementWithEmoji
            name="title"
            label={$t({
              id: 'socialExport.form.title',
              defaultMessage: 'Título',
            })}
            required
            fullWidth
          />
          <TextFieldElementWithEmoji
            name="description"
            label={$t({
              id: 'socialExport.form.description',
              defaultMessage: 'Descripción',
            })}
            required
            fullWidth
            multiline
            rows={3}
          />
        </Stack>
      </FormSectionV2>
      <FormSectionV2
        title={$t({
          id: 'socialExport.form.schedule',
          defaultMessage: 'Programación',
        })}
      >
        <Grid container>
          <Grid item md={12}>
            <SocialPublishAtField />
          </Grid>
        </Grid>
      </FormSectionV2>
      {actions}
    </FormContainer>
  );
}
